import { render } from "./AsideUserList.vue?vue&type=template&id=21a42d09&scoped=true"
import script from "./AsideUserList.vue?vue&type=script&lang=js"
export * from "./AsideUserList.vue?vue&type=script&lang=js"

import "./AsideUserList.vue?vue&type=style&index=0&id=21a42d09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a42d09"]])

export default __exports__